/*
 * fn: cn
 *
 * Classnames: Generates class names from a list of classname params
 *
 */
import { type Dict } from '@/defs/misc'

import { isNonEmptyString } from './isNonEmptyString'

type Props =
  | ({ styles: Dict<string> } & { [key: string]: undefined | boolean | string | Dict<string> })
  | string
  | false
  | undefined
  | (string | undefined)[]

export const cn = (...props: Props[]) => {
  const output: (string | undefined)[] = []

  for (const prop of props) {
    if (!prop) continue

    if (typeof prop === 'string') {
      output.push(prop)
      continue
    }

    if (Array.isArray(prop)) {
      output.push(...prop)
      continue
    }

    const styles = prop.styles
    for (const item in prop) {
      if (item === 'styles') continue
      const value = prop[item]
      if (typeof value === 'string') {
        output.push(styles[`${item}--${value}`])
        continue
      }

      if (value) {
        output.push(styles[item])
      }
    }
  }

  return output.filter(isNonEmptyString).join(' ') || undefined
}
